// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3yT4T","content":"ManualTimeModal_content__2vALG"};